import { ResponsiveBar } from '@nivo/bar';
import { getAreaShortName, dimColors } from '../constants';

const groups = ['Muy Bajo', 'Bajo', 'Neutro', 'Alto', 'Muy Alto'];

const getAreaData = ({ user }) => {
  const {
    perc_A_F,
    perc_A_HGC,
    perc_A_LL,
    perc_B_CBS,
    perc_B_CD,
    perc_B_M,
    perc_C_AI,
    perc_C_AV,
    perc_C_D
  } = user;

  const data = [
    {
      dimension: 'F',
      area: 'A',
      value: parseFloat(perc_A_F)
    },
    {
      dimension: 'HGC',
      area: 'A',
      value: parseFloat(perc_A_HGC)
    },
    {
      dimension: 'LL',
      area: 'A',
      value: parseFloat(perc_A_LL)
    },
    {
      dimension: 'CBS',
      area: 'B',
      value: parseFloat(perc_B_CBS)
    },
    {
      dimension: 'CD',
      area: 'B',
      value: parseFloat(perc_B_CD)
    },
    {
      dimension: 'M',
      area: 'B',
      value: parseFloat(perc_B_M)
    },
    {
      dimension: 'AV',
      area: 'C',
      value: parseFloat(perc_C_AV)
    },
    {
      dimension: 'AI',
      area: 'C',
      value: parseFloat(perc_C_AI)
    },
    {
      dimension: 'D',
      area: 'C',
      value: parseFloat(perc_C_D)
    }
  ];

  const getValueGroup = val => {
    const value = parseFloat(val);
    if (value < 30) {
      return 'Muy Bajo';
    }
    if (value < 40) {
      return 'Bajo';
    }
    if (value < 60) {
      return 'Neutro';
    }
    if (value < 70) {
      return 'Alto';
    }
    return 'Muy Alto';
  };
  const groupColor = group => {
    switch (group) {
      case 'Muy Bajo':
        return dimColors[0];
      case 'Bajo':
        return dimColors[1];
      case 'Neutro':
        return dimColors[2];
      case 'Alto':
        return dimColors[3];
      case 'Muy Alto':
        return dimColors[4];
      default:
        return dimColors[0];
    }
  };

  // const filteredData = data.filter(dp => {
  //   const isZero = dp.value === 0;
  //   const isFalsy = !dp.value;
  //   return !isFalsy || isZero;
  // });

  const dataWithDetails = data.reverse().map(el => {
    const group = getValueGroup(el.value);
    const color = groupColor(group);
    return { ...el, group, color };
  });

  const groupedData = dataWithDetails.map(dp => {
    const groupsvals = groups.reduce((acc, curr) => {
      let val = 0;
      if (curr === dp.group) {
        val = dp.value;
      }
      return { ...acc, [curr]: val };
    }, {});

    return {
      ...dp,
      dimension: dp.dimension,
      ...groupsvals
    };
  });
  return groupedData;
};

const getFilteredArea = ({ areasData, electivos }) => {
  const filteredData = areasData.filter(dp => {
    const currElectivo = electivos.find(e => e.id === dp.area);
    return currElectivo && currElectivo.available;
  });
  return filteredData;
};

const getFilteredData = ({ areasData, electivos }) => {
  const allDisciplines = electivos.map(dp => dp.disciplinas).flat();
  const filteredAreas = getFilteredArea({ areasData, electivos });
  const filteredData = filteredAreas.filter(dp => {
    const curr = allDisciplines.find(e => e.id === dp.dimension);
    return curr && curr.available;
  });
  return filteredData;
};

const MyResponsiveBar = ({ user, electivos }) => {
  const areasData = getAreaData({ user });
  const filteredData = getFilteredData({ areasData, electivos });
  return (
    <ResponsiveBar
      data={filteredData}
      keys={groups}
      indexBy='dimension'
      layout='horizontal'
      // groupMode='grouped'
      isInteractive={false}
      margin={{ top: 20, right: 90, bottom: 40, left: 155 }}
      padding={0.3}
      maxValue={100}
      valueScale={{ type: 'linear' }}
      colors={dimColors}
      borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
      axisTop={null}
      axisRight={null}
      enableGridX
      enableGridY={false}
      axisLeft={{
        format: v => getAreaShortName(v)
      }}
      label={d => `${parseFloat(d.value).toFixed(0)}`}
      labelSkipWidth={12}
      labelSkipHeight={12}
      legends={[
        {
          anchor: 'right',
          direction: 'column',
          justify: false,
          translateX: 110,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: 'left-to-right',
          itemOpacity: 0.85,
          symbolSize: 20
        }
      ]}
      animate={false}
      motionStiffness={90}
      motionDamping={15}
    />
  );
};

export default MyResponsiveBar;
